var route = {
    path : '/login/subAccount(/:subid)',
    getComponent(nextState, cb) {
        
        require.ensure([], (require) => {
            cb(null, require('../pc/SubAccountLogin.jsx').default)
        }, 'home')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/SubAccountLogin.js